'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactCssThemr = require('react-css-themr');

var _SkipToContent = require('./SkipToContent');

var _SkipToContent2 = _interopRequireDefault(_SkipToContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactCssThemr.themr)('@spp/skip-to-content')(_SkipToContent2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-skip-to-content/lib/cjs/index.js
 ** module id = 670
 ** module chunks = 1
 **/